import { AppBar, Dialog, Toolbar, WithStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import GetAppIcon from '@material-ui/icons/GetApp';
import RefreshIcon from '@material-ui/icons/Refresh';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { UpwardTransition } from 'src/utils';

import { CurriculumTypes } from '../components/CurriculumCard';
import { ElearningTypes } from '../components/ELearningCard';

import * as Actions from '../actions/imstat';
import { IUserAttr } from '../actions/session';
import ImstatCurriculumCard from '../components/ImstatCurriculumCard';
import ImstatDistanceLearningCard from '../components/ImstatDistanceLearningCard';
import ImstatELearningCard from '../components/ImstatELearningCard';
import ImstatGroupTrainingCard from '../components/ImstatGroupTrainingCard';
import CardIcon from '../icons/ImstatCard';
import TableIcon from '../icons/ImstatTable';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import ScenariFactory from '../scenario/ImstatScenarioFactory';
import Config from '../site.config.json';
import { getSystemMst, isValid, MasterItemCode } from '../utils/MasterData';
import { isMobile } from '../utils/MobileCheck';
import ImstatCurriculumTable, {
	CurriculumTypes as TableCurriculumTypes,
} from './ImstatCurriculumTable';
import ImstatDistanceLearningTable, {
	DistanceLearningTypes,
} from './ImstatDistanceLearningTable';
import ImstatELearningTable from './ImstatELearningTable';
import { ELearningTableTypes } from './ImstatELearningTable';
import { GroupTrainingTypes } from './ImstatGroupTrainingTable';
import ImstatGroupTrainingTable from './ImstatGroupTrainingTable';

// shortcut
import ShowTypes = Actions.ImstatShowTypes;
import ApplicationStatus from './ApplicationStatus';
import CareerDetail from './CareerDetail';
import CurriculumDetail from './CurriculumDetail';

export enum TableRow {
	E_LEARNING,
	GROUP_TRAINING,
	DISTANCE_LEARNING,
	CURRICULUM,
}

const styles = (theme: Theme) =>
	createStyles({
		appBar: {
			position: 'relative',
			width: 'auto',
		},
		caption: {
			marginTop: -14,
		},
		careerDialog: {
			width: '80%',
		},
		flex: {
			flex: 1,
		},
		paper: {
			marginBottom: theme.spacing(1),
			marginLeft: theme.spacing(1),
			marginRight: theme.spacing(1),
			marginTop: theme.spacing(2),
			paddingBottom: theme.spacing(2),
			paddingLeft: theme.spacing(1),
			paddingRight: theme.spacing(1),
			paddingTop: theme.spacing(0),
		},
		placeholder: {
			minHeight: 10,
			width: '100%',
		},
	});

/**
 * 実績受講・実績状況
 */
class ImstatResult extends React.Component<IProps> {
	protected csvDownloadFormELearning: HTMLFormElement | null;
	protected csvDownloadFormGroupTraining: HTMLFormElement | null;
	protected csvDownloadFormDistanceLearning: HTMLFormElement | null;
	protected csvDownloadFormCurriculum: HTMLFormElement | null;

	public constructor(props: IProps) {
		super(props);

		this.downloadCsv = this.downloadCsv.bind(this);
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidMount() {
		if (!this.props.fetchDefaultDisplayFormatAt && !isMobile()) {
			this.props.fetchDefaultDisplaySetting(this.props.token);
		}
		if (!this.props.resultELearning.setDataAt) {
			this.props.fetchResultELearning(
				this.props.token,
				this.props.userAttr,
				this.props.onlyQualificationDispalyFlg
			);
		}
		const f = getSystemMst(MasterItemCode.CAREER_TYPE_CONTROL);
		if (f && !this.props.resultGroupTraining.setDataAt) {
			this.props.fetchResultGroupTraining(
				this.props.token,
				this.props.userAttr
			);
		}
		if (f && !this.props.resultDistanceLearning.setDataAt) {
			this.props.fetchResultDistanceLearning(
				this.props.token,
				this.props.userAttr
			);
		}
		if (!this.props.resultCurriculum.setDataAt) {
			this.props.fetchResultCurriculum(
				this.props.token,
				this.props.userAttr
			);
		}
	}

	public componentWillUnmount() {
		this.props.clearImstatParams();
	}

	public componentWillUpdate(nextProps: IProps) {
		if (this.props.resultELearning !== nextProps.resultELearning) {
			return true;
		}
		return false;
	}

	public render() {
		const {
			classes,
			resultELearning,
			resultGroupTraining,
			resultDistanceLearning,
			resultCurriculum,
			userAttr,
		} = this.props;
		const { userId, locale } = userAttr;

		return (
			<>
				<Paper className={classes.paper} id="e-learning">
					<Grid container={true} alignItems="flex-end">
						<Grid item={true} className={classes.flex}>
							<Typography variant="h6">
								{i18n.t('ImstatResult_0001')}
							</Typography>
						</Grid>
						{!isMobile() && (
							<>
								<Grid item={true}>
									<IconButton
										onClick={this.handleClickCard(
											TableRow.E_LEARNING
										)}
										color="primary"
										disabled={
											this.props.resultELearning
												.showType ===
											ShowTypes.IMSTAT_SHOW_TYPE_CARD
										}
									>
										<CardIcon />
									</IconButton>
									<Typography
										variant="caption"
										align="center"
										className={classes.caption}
										display="block"
									>
										{i18n.t('ImstatResult_0002')}
									</Typography>
								</Grid>
								<Grid item={true}>
									<IconButton
										onClick={this.handleClickTable(
											TableRow.E_LEARNING
										)}
										color="primary"
										disabled={
											this.props.resultELearning
												.showType ===
											ShowTypes.IMSTAT_SHOW_TYPE_TABLE
										}
									>
										<TableIcon />
									</IconButton>
									<Typography
										variant="caption"
										align="center"
										className={classes.caption}
										display="block"
									>
										{i18n.t('ImstatResult_0003')}
									</Typography>
								</Grid>
								<Grid item={true}>
									<IconButton
										onClick={this.downloadCsv(
											TableRow.E_LEARNING
										)}
										color="primary"
									>
										<GetAppIcon />
									</IconButton>
									<Typography
										variant="caption"
										align="center"
										className={classes.caption}
										display="block"
									>
										{i18n.t('ImstatResult_0004')}
									</Typography>
								</Grid>
							</>
						)}
						<Grid item={true}>
							<IconButton
								onClick={this.reloadResult(TableRow.E_LEARNING)}
								color="primary"
							>
								<RefreshIcon />
							</IconButton>
							<Typography
								variant="caption"
								align="center"
								className={classes.caption}
								display="block"
							>
								{i18n.t('ImstatResult_0005')}
							</Typography>
						</Grid>
					</Grid>
					{(() => {
						switch (resultELearning.showType) {
							case ShowTypes.IMSTAT_SHOW_TYPE_TABLE:
								// eラーニングのテーブル表示
								return (
									<div className={classes.placeholder}>
										<ImstatELearningTable
											data={resultELearning.data}
											selectedColumns={
												resultELearning.selectedColumns
											}
											type={ELearningTableTypes.RESULT}
										/>
									</div>
								);
							case ShowTypes.IMSTAT_SHOW_TYPE_CARD:
								// eラーニングのカード表示
								return (
									<div className={classes.placeholder}>
										<ImstatELearningCard
											data={resultELearning.data}
											type={ElearningTypes.RESULT}
										/>
									</div>
								);
							default:
								// eラーニングの初期表示
								return <div />;
						}
					})()}
				</Paper>
				{isValid(MasterItemCode.CAREER_TYPE_CONTROL) && (
					<Paper className={classes.paper} id="group-training">
						<Grid container={true} alignItems="flex-end">
							<Grid item={true} className={classes.flex}>
								<Typography variant="h6">
									{i18n.t('ImstatResult_0006')}
								</Typography>
							</Grid>
							{!isMobile() && (
								<>
									<Grid item={true}>
										<IconButton
											onClick={this.handleClickCard(
												TableRow.GROUP_TRAINING
											)}
											color="primary"
											disabled={
												this.props.resultGroupTraining
													.showType ===
												ShowTypes.IMSTAT_SHOW_TYPE_CARD
											}
										>
											<CardIcon />
										</IconButton>
										<Typography
											variant="caption"
											align="center"
											className={classes.caption}
											display="block"
										>
											{i18n.t('ImstatResult_0007')}
										</Typography>
									</Grid>
									<Grid item={true}>
										<IconButton
											onClick={this.handleClickTable(
												TableRow.GROUP_TRAINING
											)}
											color="primary"
											disabled={
												this.props.resultGroupTraining
													.showType ===
												ShowTypes.IMSTAT_SHOW_TYPE_TABLE
											}
										>
											<TableIcon />
										</IconButton>
										<Typography
											variant="caption"
											align="center"
											className={classes.caption}
											display="block"
										>
											{i18n.t('ImstatResult_0008')}
										</Typography>
									</Grid>
									<Grid item={true}>
										<IconButton
											onClick={this.downloadCsv(
												TableRow.GROUP_TRAINING
											)}
											color="primary"
										>
											<GetAppIcon />
										</IconButton>
										<Typography
											variant="caption"
											align="center"
											className={classes.caption}
											display="block"
										>
											{i18n.t('ImstatResult_0009')}
										</Typography>
									</Grid>
								</>
							)}
							<Grid item={true}>
								<IconButton
									onClick={this.reloadResult(
										TableRow.GROUP_TRAINING
									)}
									color="primary"
								>
									<RefreshIcon />
								</IconButton>
								<Typography
									variant="caption"
									align="center"
									className={classes.caption}
									display="block"
								>
									{i18n.t('ImstatResult_0010')}
								</Typography>
							</Grid>
						</Grid>
						{(() => {
							switch (resultGroupTraining.showType) {
								case ShowTypes.IMSTAT_SHOW_TYPE_TABLE:
									// 集合研修のテーブル表示
									return (
										<div className={classes.placeholder}>
											<ImstatGroupTrainingTable
												data={resultGroupTraining.data}
												selectedColumns={
													resultGroupTraining.selectedColumns
												}
												type={GroupTrainingTypes.RESULT}
											/>
										</div>
									);
								case ShowTypes.IMSTAT_SHOW_TYPE_CARD:
									// 集合研修のカード表示
									return (
										<div className={classes.placeholder}>
											<ImstatGroupTrainingCard
												data={resultGroupTraining.data}
												type={GroupTrainingTypes.RESULT}
											/>
										</div>
									);
								default:
									// 集合研修の初期表示
									return <div />;
							}
						})()}
					</Paper>
				)}
				{isValid(MasterItemCode.CAREER_TYPE_CONTROL) && (
					<Paper className={classes.paper} id="distance-learning">
						<Grid container={true} alignItems="flex-end">
							<Grid item={true} className={classes.flex}>
								<Typography variant="h6">
									{i18n.t('ImstatResult_0011')}
								</Typography>
							</Grid>
							{!isMobile() && (
								<>
									<Grid item={true}>
										<IconButton
											onClick={this.handleClickCard(
												TableRow.DISTANCE_LEARNING
											)}
											color="primary"
											disabled={
												this.props
													.resultDistanceLearning
													.showType ===
												ShowTypes.IMSTAT_SHOW_TYPE_CARD
											}
										>
											<CardIcon />
										</IconButton>
										<Typography
											variant="caption"
											align="center"
											className={classes.caption}
											display="block"
										>
											{i18n.t('ImstatResult_0012')}
										</Typography>
									</Grid>
									<Grid item={true}>
										<IconButton
											onClick={this.handleClickTable(
												TableRow.DISTANCE_LEARNING
											)}
											color="primary"
											disabled={
												this.props
													.resultDistanceLearning
													.showType ===
												ShowTypes.IMSTAT_SHOW_TYPE_TABLE
											}
										>
											<TableIcon />
										</IconButton>
										<Typography
											variant="caption"
											align="center"
											className={classes.caption}
											display="block"
										>
											{i18n.t('ImstatResult_0013')}
										</Typography>
									</Grid>
									<Grid item={true}>
										<IconButton
											onClick={this.downloadCsv(
												TableRow.DISTANCE_LEARNING
											)}
											color="primary"
										>
											<GetAppIcon />
										</IconButton>
										<Typography
											variant="caption"
											align="center"
											className={classes.caption}
											display="block"
										>
											{i18n.t('ImstatResult_0014')}
										</Typography>
									</Grid>
								</>
							)}
							<Grid item={true}>
								<IconButton
									onClick={this.reloadResult(
										TableRow.DISTANCE_LEARNING
									)}
									color="primary"
								>
									<RefreshIcon />
								</IconButton>
								<Typography
									variant="caption"
									align="center"
									className={classes.caption}
									display="block"
								>
									{i18n.t('ImstatResult_0015')}
								</Typography>
							</Grid>
						</Grid>
						{(() => {
							switch (resultDistanceLearning.showType) {
								case ShowTypes.IMSTAT_SHOW_TYPE_TABLE:
									// 通信教育のテーブル表示
									return (
										<div className={classes.placeholder}>
											<ImstatDistanceLearningTable
												data={
													resultDistanceLearning.data
												}
												selectedColumns={
													resultDistanceLearning.selectedColumns
												}
												type={
													DistanceLearningTypes.RESULT
												}
											/>
										</div>
									);
								case ShowTypes.IMSTAT_SHOW_TYPE_CARD:
									// 通信教育のカード表示
									return (
										<div className={classes.placeholder}>
											<ImstatDistanceLearningCard
												data={
													resultDistanceLearning.data
												}
												type={
													DistanceLearningTypes.RESULT
												}
											/>
										</div>
									);
								default:
									// 通信教育の初期表示
									return <div />;
							}
						})()}
					</Paper>
				)}
				<Paper className={classes.paper} id="curriculum">
					<Grid container={true} alignItems="flex-end">
						<Grid item={true} className={classes.flex}>
							<Typography variant="h6">
								{i18n.t('ImstatResult_0016')}
							</Typography>
						</Grid>
						{!isMobile() && (
							<>
								<Grid item={true}>
									<IconButton
										onClick={this.handleClickCard(
											TableRow.CURRICULUM
										)}
										color="primary"
										disabled={
											this.props.resultCurriculum
												.showType ===
											ShowTypes.IMSTAT_SHOW_TYPE_CARD
										}
									>
										<CardIcon />
									</IconButton>
									<Typography
										variant="caption"
										align="center"
										className={classes.caption}
										display="block"
									>
										{i18n.t('ImstatResult_0017')}
									</Typography>
								</Grid>
								<Grid item={true}>
									<IconButton
										onClick={this.handleClickTable(
											TableRow.CURRICULUM
										)}
										color="primary"
										disabled={
											this.props.resultCurriculum
												.showType ===
											ShowTypes.IMSTAT_SHOW_TYPE_TABLE
										}
									>
										<TableIcon />
									</IconButton>
									<Typography
										variant="caption"
										align="center"
										className={classes.caption}
										display="block"
									>
										{i18n.t('ImstatResult_0018')}
									</Typography>
								</Grid>
								<Grid item={true}>
									<IconButton
										onClick={this.downloadCsv(
											TableRow.CURRICULUM
										)}
										color="primary"
									>
										<GetAppIcon />
									</IconButton>
									<Typography
										variant="caption"
										align="center"
										className={classes.caption}
										display="block"
									>
										{i18n.t('ImstatResult_0019')}
									</Typography>
								</Grid>
							</>
						)}
						<Grid item={true}>
							<IconButton
								onClick={this.reloadResult(TableRow.CURRICULUM)}
								color="primary"
							>
								<RefreshIcon />
							</IconButton>
							<Typography
								variant="caption"
								align="center"
								className={classes.caption}
								display="block"
							>
								{i18n.t('ImstatResult_0020')}
							</Typography>
						</Grid>
					</Grid>
					{(() => {
						switch (resultCurriculum.showType) {
							case ShowTypes.IMSTAT_SHOW_TYPE_TABLE:
								// カリキュラムのテーブル表示
								return (
									<div className={classes.placeholder}>
										<ImstatCurriculumTable
											data={resultCurriculum.data}
											selectedColumns={
												resultCurriculum.selectedColumns
											}
											type={TableCurriculumTypes.RESULT}
										/>
									</div>
								);
							case ShowTypes.IMSTAT_SHOW_TYPE_CARD:
								// カリキュラムのカード表示
								return (
									<div className={classes.placeholder}>
										<ImstatCurriculumCard
											data={resultCurriculum.data}
											type={CurriculumTypes.RESULT}
										/>
									</div>
								);
							default:
								// カリキュラムの初期表示
								return <div />;
						}
					})()}
				</Paper>
				<form
					method="POST"
					action={
						Config.tsqPath +
						'/tsq/pkg/action/per/downloadResultCsv.action'
					}
					ref={form => (this.csvDownloadFormELearning = form)}
					target="_blank"
				>
					<input
						type="hidden"
						name="searchCondition"
						value={`{"userId":"${userId}","locale":"${locale}","lang":"${
							i18n.language
						}","accessType":"${10}","culFlg":"${false}","careerTypeId":"${1}","onlyQualificationDispalyFlg":"${
							this.props.onlyQualificationDispalyFlg
						}"}`}
					/>
					<input
						type="hidden"
						name="__tsqCookieName"
						value="TSQ_FD_0"
					/>
					<input type="hidden" name="__tsqFileType" value="csv" />
				</form>
				<form
					method="POST"
					action={
						Config.tsqPath +
						'/tsq/pkg/action/per/downloadResultCsv.action'
					}
					ref={form => (this.csvDownloadFormGroupTraining = form)}
					target="_blank"
				>
					<input
						type="hidden"
						name="searchCondition"
						value={`{"userId":"${userId}","locale":"${locale}","lang":"${
							i18n.language
						}","accessType":"${10}","culFlg":"${false}","careerTypeId":"${2}"}`}
					/>
					<input
						type="hidden"
						name="__tsqCookieName"
						value="TSQ_FD_0"
					/>
					<input type="hidden" name="__tsqFileType" value="csv" />
				</form>
				<form
					method="POST"
					action={
						Config.tsqPath +
						'/tsq/pkg/action/per/downloadResultCsv.action'
					}
					ref={form => (this.csvDownloadFormDistanceLearning = form)}
					target="_blank"
				>
					<input
						type="hidden"
						name="searchCondition"
						value={`{"userId":"${userId}","locale":"${locale}","lang":"${
							i18n.language
						}","accessType":"${10}","culFlg":"${false}","careerTypeId":"${3}"}`}
					/>
					<input
						type="hidden"
						name="__tsqCookieName"
						value="TSQ_FD_0"
					/>
					<input type="hidden" name="__tsqFileType" value="csv" />
				</form>
				<form
					method="POST"
					action={
						Config.tsqPath +
						'/tsq/pkg/action/per/downloadResultCsv.action'
					}
					ref={form => (this.csvDownloadFormCurriculum = form)}
					target="_blank"
				>
					<input
						type="hidden"
						name="searchCondition"
						value={`{"userId":"${userId}","locale":"${locale}","lang":"${
							i18n.language
						}","accessType":"${10}","culFlg":"${true}","careerTypeId":"${90}"}`}
					/>
					<input
						type="hidden"
						name="__tsqCookieName"
						value="TSQ_FD_0"
					/>
					<input type="hidden" name="__tsqFileType" value="csv" />
				</form>
				<Dialog
					fullScreen={false}
					TransitionComponent={UpwardTransition}
					open={
						this.props.careerDetailDialog.setOpenCareerDetailDialog
					}
					onClose={this.handlecloseDetailDialog}
					fullWidth={true}
					maxWidth={false}
					classes={{
						paperFullWidth: this.props.classes.careerDialog,
					}}
				>
					<AppBar className={this.props.classes.appBar}>
						<Toolbar>
							<IconButton
								color="inherit"
								aria-label="Close"
								onClick={this.handlecloseDetailDialog}
							>
								<CloseIcon />
							</IconButton>
							<Typography variant="h6" color="inherit">
								{i18n.t('ImstatResult_0021')}
							</Typography>
						</Toolbar>
					</AppBar>
					<CareerDetail
						careerID={this.props.careerDetailDialog.careerID}
					/>
				</Dialog>
				<Dialog
					fullScreen={false}
					TransitionComponent={UpwardTransition}
					open={
						this.props.careerDetailDialog
							.setOpenCurriculumDetailDialog
					}
					onClose={this.handlecloseDetailDialog}
					fullWidth={true}
					maxWidth={false}
					classes={{
						paperFullWidth: this.props.classes.careerDialog,
					}}
				>
					<AppBar className={this.props.classes.appBar}>
						<Toolbar>
							<IconButton
								color="inherit"
								aria-label="Close"
								onClick={this.handlecloseDetailDialog}
							>
								<CloseIcon />
							</IconButton>
							<Typography variant="h6" color="inherit">
								{i18n.t('ImstatResult_0022')}
							</Typography>
						</Toolbar>
					</AppBar>
					<CurriculumDetail
						curriculumId={this.props.careerDetailDialog.careerID}
					/>
				</Dialog>
				<Dialog
					fullScreen={false}
					TransitionComponent={UpwardTransition}
					open={
						this.props.careerDetailDialog.setApplicationStatusDialog
					}
					onClose={this.handlecloseDetailDialog}
					fullWidth={true}
					maxWidth={false}
					classes={{
						paperFullWidth: this.props.classes.careerDialog,
					}}
				>
					<AppBar className={this.props.classes.appBar}>
						<Toolbar>
							<IconButton
								color="inherit"
								aria-label="Close"
								onClick={this.handlecloseDetailDialog}
							>
								<CloseIcon />
							</IconButton>
							<Typography variant="h6" color="inherit">
								{i18n.t('ImstatResult_0023')}
							</Typography>
						</Toolbar>
					</AppBar>
					<ApplicationStatus
						careerID={this.props.careerDetailDialog.careerID}
						classID={this.props.careerDetailDialog.classID}
						apllType={this.props.careerDetailDialog.apllType}
						curriculumFlg={
							this.props.careerDetailDialog.curriculumFlg
						}
					/>
				</Dialog>
			</>
		);
	}

	protected handlecloseDetailDialog = () => {
		const careerDetailDialog: Actions.ICareerDetailDialog = {
			apllType: '',
			careerID: '',
			classID: '',
			curriculumFlg: '0',
			setApplicationStatusDialog: false,
			setOpenCareerDetailDialog: false,
			setOpenCurriculumDetailDialog: false,
		};
		this.props.setCareerDetailDialog(careerDetailDialog);
	};

	/**
	 * 表示情報読み込み
	 */
	protected reloadResult = (tableType: number) => () => {
		switch (tableType) {
			case TableRow.E_LEARNING:
				this.props.fetchResultELearning(
					this.props.token,
					this.props.userAttr,
					this.props.onlyQualificationDispalyFlg
				);
				break;
			case TableRow.GROUP_TRAINING:
				this.props.fetchResultGroupTraining(
					this.props.token,
					this.props.userAttr
				);
				break;
			case TableRow.DISTANCE_LEARNING:
				this.props.fetchResultDistanceLearning(
					this.props.token,
					this.props.userAttr
				);
				break;
			case TableRow.CURRICULUM:
				this.props.fetchResultCurriculum(
					this.props.token,
					this.props.userAttr
				);
				break;
			default:
		}
	};

	/**
	 * カード表示クリックハンドラ
	 */
	protected handleClickCard = (tableType: number) => () => {
		switch (tableType) {
			case TableRow.E_LEARNING:
				this.props.setResultELearningShowType(
					ShowTypes.IMSTAT_SHOW_TYPE_CARD
				);
				break;
			case TableRow.GROUP_TRAINING:
				this.props.setResultGroupTrainingShowType(
					ShowTypes.IMSTAT_SHOW_TYPE_CARD
				);
				break;
			case TableRow.DISTANCE_LEARNING:
				this.props.setResultDistanceLearningShowType(
					ShowTypes.IMSTAT_SHOW_TYPE_CARD
				);
				break;
			case TableRow.CURRICULUM:
				this.props.setResultCurriculumShowType(
					ShowTypes.IMSTAT_SHOW_TYPE_CARD
				);
				break;
			default:
		}
	};

	/**
	 * テーブル表示クリックハンドラ
	 */
	protected handleClickTable = (tableType: number) => () => {
		switch (tableType) {
			case TableRow.E_LEARNING:
				this.props.setResultELearningShowType(
					ShowTypes.IMSTAT_SHOW_TYPE_TABLE
				);
				break;
			case TableRow.GROUP_TRAINING:
				this.props.setResultGroupTrainingShowType(
					ShowTypes.IMSTAT_SHOW_TYPE_TABLE
				);
				break;
			case TableRow.DISTANCE_LEARNING:
				this.props.setResultDistanceLearningShowType(
					ShowTypes.IMSTAT_SHOW_TYPE_TABLE
				);
				break;
			case TableRow.CURRICULUM:
				this.props.setResultCurriculumShowType(
					ShowTypes.IMSTAT_SHOW_TYPE_TABLE
				);
				break;
			default:
		}
	};

	/**
	 * CSVダウンロード実行
	 */
	protected downloadCsv = (tableType: number) => () => {
		switch (tableType) {
			case TableRow.E_LEARNING:
				if (this.csvDownloadFormELearning) {
					this.csvDownloadFormELearning.submit();
				}
				break;
			case TableRow.GROUP_TRAINING:
				if (this.csvDownloadFormGroupTraining) {
					this.csvDownloadFormGroupTraining.submit();
				}
				break;
			case TableRow.DISTANCE_LEARNING:
				if (this.csvDownloadFormDistanceLearning) {
					this.csvDownloadFormDistanceLearning.submit();
				}
				break;
			case TableRow.CURRICULUM:
				if (this.csvDownloadFormCurriculum) {
					this.csvDownloadFormCurriculum.submit();
				}
				break;
			default:
		}
	};
}

const mapStateToProps = (state: IRootState) => ({
	careerDetailDialog: state.imstat.careerDetailDialog,
	fetchDefaultDisplayFormatAt: state.imstat.fetchDefaultDisplayFormatAt,
	resultCurriculum: state.imstat.resultCurriculum,
	resultDistanceLearning: state.imstat.resultDistanceLearning,
	resultELearning: state.imstat.resultELearning,
	resultGroupTraining: state.imstat.resultGroupTraining,
	token: state.session.token,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	clearImstatParams: () => dispatch(Actions.clearImstat()),
	fetchDefaultDisplaySetting: (token: string) => {
		const s = ScenariFactory.createFetchDefaultDisplaySetting(
			dispatch,
			token
		);
		s.run({});
	},
	fetchResultCurriculum: (token: string, arg: IUserAttr) => {
		const s = ScenariFactory.createFetchResultCurriculum(dispatch, token);
		s.run(arg);
	},
	fetchResultDistanceLearning: (token: string, arg: IUserAttr) => {
		const s = ScenariFactory.createFetchResultDistanceLearning(
			dispatch,
			token
		);
		s.run(arg);
	},
	fetchResultELearning: (
		token: string,
		arg: IUserAttr,
		onlyQualificationDispalyFlg: string
	) => {
		const s = ScenariFactory.createFetchResultELearning(
			dispatch,
			token,
			onlyQualificationDispalyFlg
		);
		s.run(arg);
	},
	fetchResultGroupTraining: (token: string, arg: IUserAttr) => {
		const s = ScenariFactory.createFetchResultGroupTraining(
			dispatch,
			token
		);
		s.run(arg);
	},
	setResultCurriculumShowType: (type: Actions.ImstatShowTypes) =>
		dispatch(Actions.setImstatResultCurriculumShowType({ showType: type })),
	setResultDistanceLearningShowType: (type: Actions.ImstatShowTypes) =>
		dispatch(
			Actions.setImstatResultDistanceLearningShowType({ showType: type })
		),
	setResultELearningShowType: (type: Actions.ImstatShowTypes) =>
		dispatch(Actions.setImstatResultELearningShowType({ showType: type })),
	setResultGroupTrainingShowType: (type: Actions.ImstatShowTypes) =>
		dispatch(
			Actions.setImstatResultGroupTrainingShowType({ showType: type })
		),

	setCareerDetailDialog: (CareerDetailDialog: Actions.ICareerDetailDialog) =>
		dispatch(Actions.setCareerDetailDialog({ CareerDetailDialog })),
});

// tslint:disable-next-line: no-empty-interface
export interface IImstatResultProps {
	onlyQualificationDispalyFlg: string;
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & IImstatResultProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(ImstatResult);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/containers/ImstatResult.tsx